module.exports = __webpack_public_path__ + "static/media/video.57fd287d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/OnboardingDemo/assets/video.jpg
// module id = 499
// module chunks = 0